const PROJECTS = [
  {
    slug: 'penny',
    title: 'Penny',
    link: 'http://penny.digitalglobe.com/',
    dt: '06/27/2017',
    images: ['penny.png'],
    desc: "Penny is a simple tool to help us understand what wealth and poverty look like to an artificial intelligence built on machine learning using neural networks.",
    roles: [
      'Lead React / Redux developer',
      'Initial image classifier & image recognition prototyping',
      'Conceptual development',
      'Setup Python backend with API services',
      'AWS EB integration'
    ]
  },
  {
    slug: 'openearth',
    title: 'Open Earth',
    link: 'https://stamen.com/work/open-earth/',
    dt: '02/01/2016',
    images: ['openearth.gif'],
    desc: "Interface prototype for the geo-journalism organization, Earth Journalism Network.",
    roles: [
      'Lead React / Redux developer'
    ]
  },
  {
    slug: 'surgingseas',
    title: 'Surging Seas',
    link: 'https://stamen.com/work/surging-seas-2/',
    dt: '10/01/2015',
    images: ['ss2-5ft.png'],
    desc: "Explorative map of rising sea level scenarios for Climate Central and New American Media.",
    roles: [
      'Lead front end developer'
    ]
  },
  {
    slug: 'm2i',
    title: 'Map2Image',
    link: 'http://maps.stamen.com/m2i',
    dt: '12/01/2012',
    images: ['map2image.png'],
    desc: "A service that allows users to stitch Stamen Design map tiles into a singular image.",
    roles: [
      'Lead front end developer',
      'Created API endpoints and backend rendering services'
    ]
  },
  {
    slug: 'foreignborn',
    title: 'Foreign-Born Population',
    link: 'http://dsl.richmond.edu/panorama/foreignborn',
    dt: '12/15/2015',
    images: ['foreign-born.png'],
    desc: "Explorative map of how many Americans were born in other countries, where they came from, and where they settled for the Digital Scholarship Lab at the University of Richmond.",
    roles: [
      'Lead React / Redux developer'
    ]
  },
  {
    slug: 'ggnpc-map',
    title: 'Golden Gate National Parks Conservancy',
    link: 'http://parksconservancy.org/map',
    dt: '12/01/2013',
    images: ['parks.png'],
    desc: "Explorative map to help more locals (and tourists) get outside and into the Golden Gate National Recreation Area, the nation’s largest urban national park.",
    roles: [
      'Lead front end developer',
      'Created a pipeline to move data from client CMS to a relational database'
    ]
  },
  {
    slug: 'jawbone',
    title: 'Jawbone at TED 2013',
    link: 'http://content.stamen.com/jawbone_at_ted',
    dt: '02/01/2013',
    images: ['jawbone.jpg'],
    desc: "Visualization prototype for Jawbone showing the behavior of several hundred users.",
    roles: [
      'Data exploration and protoyping'
    ]
  }

];


export default PROJECTS;


// WEBPACK FOOTER //
// ./src/constants/projects.js